import * as React from 'react';
import { NiButton } from '@component/index';
import { FormattedMessage } from 'react-intl';
import '@style/component/buttons/page-confirm-btn.less';

export interface PageConfirmButtonProp {
  onConfirm?: () => void;
  onCancel?: () => void;
  loading?: boolean;
  customConfirmButton?: JSX.Element;
}

export interface PageConfirmButtonState { }

export class PageConfirmButton extends React.Component<
  PageConfirmButtonProp,
  PageConfirmButtonState
  > {
  render() {
    const { loading, onConfirm, onCancel, customConfirmButton } = this.props;

    return (
      <div className="confirm-btn-area">
        <NiButton
          key="cancel-btn"
          className="header-btn light sm btn1"
          onClick={onCancel}
        >
          <FormattedMessage id="common_cancel" tagName="span" />
        </NiButton>

        {customConfirmButton}
        {!customConfirmButton && <NiButton
          key="confirm-btn"
          type="primary"
          loading={loading}
          className="header-btn sm btn2"
          onClick={onConfirm}
        >
          <FormattedMessage id="common_confirm" tagName="span" />
        </NiButton>}
      </div>
    );
  }
}
